export default __webpack_public_path__ + "9f983122538e5fe2d55f0cff77ad94eb.jpg";